/*
 * @Date: 2023-06-28 15:40:14
 * @LastEditTime: 2023-07-04 17:13:14
 * @FilePath: /RN/public/components/device/Utils/CxCyUtils.js
 * 这个类是为了 
 */


// import { CxCyToRGBHex } from "./CxCyToRGB";
import { CxCyToRGBHex } from "@/utils/colors.js";

export class CxCyUtils {

    constructor(props)
    { 
        const { config,matrix } = props; 
        this.config = config 
        this.matrix = matrix; 
        this._genValueMap(config);
    }


    _genValueMap = () => {
        const valueMap = {};
        const coordinateMap = {};
        for (let i = 0; i < this.matrix; i++) {
            for (let j = 0; j < this.matrix; j++) {
                const { cx, cy ,RGB} = this._genXY2CxCY(i, j);

                const a = parseInt(cx * 10000);
                const b = parseInt(cy * 10000);
                let value = (a & 0x0000FFFF) << 16 | b & 0x0000FFFF;
                const coordinate = i + ',' + j;
                valueMap[value] = coordinate;
                coordinateMap[coordinate] = {value,cx,cy,RGB};
            }
        }
        this.valueMap = valueMap;
        this.coordinateMap = coordinateMap;
        // console.log(' this.valueMap****', this.valueMap, coordinateMap)
    }

    _value2CxCy(value) {
        let cx = (value >> 16 & 0xffff) / 10000;
        let cy = (value & 0xffff) / 10000;
        return { cx, cy };
    }


    _genXY2CxCY(i, j) {
        const config = this.config 

        if (!config) throw new Error('no config');


        let cx, cy
        const count = this.matrix - 1;
        const maxX = this.matrix - 1;
        const maxY = this.matrix - 1;

        // 限制范围并翻转Y轴索引 (0->顶部, maxY->底部)
        if (i > maxX) i = maxX;
        if (j > maxY) j = maxY;

        
        // 检测配置结构决定使用哪种算法
        if (config.xy !== undefined && config.xc !== undefined) {
            
            /* V2版本 */
            const j_new = maxY - j; // 翻转Y轴：左上角为原点
            
            const { xr, yr, xy, yy, xb:configXb, yb:configYb, xc, yc:configYc } = config;
            
            // 处理可能的xg/yg配置（默认为xy/yy）
            const xg = config.xg !== undefined ? config.xg : xy;
            const yg = config.yg !== undefined ? config.yg : yy;
            
            // 归一化函数
            function ratioMap(minIn, maxIn, value, minOut, maxOut) {
                return minOut + (value - minIn) * (maxOut - minOut) / (maxIn - minIn);
            }

            // 使用翻转后的j_new计算坐标
            const x = ratioMap(0, count, i, 0, 1);
            const y = ratioMap(0, count, j_new, 0, 1); // 注意：y方向已翻转

            // 计算cx/cy（逻辑不变，但y方向已翻转）
            const xa = (xg - xc) * x + xc;
            const xb = (xr - configXb) * x + configXb;
            cx = (xb - xa) * y + xa;
            
            const yc_val = (configYc - configYb) * (1 - y) + configYb;
            const yd = (yg - yr) * (1 - y) + yr;
            cy = (yc_val - yd) * (1 - x) + yd;
        }else{
            /* V1版本 */
            const count = this.matrix - 1;
            const maxX = this.matrix - 1;
            const maxY = this.matrix - 1;

            if (i > maxX) i = maxX;
            if (j > maxY) j = maxY;

            const { xr, yr, xg, yg, xb, yb, coefficient } = config;
            const xa = xg + coefficient * (xr - xg);
            const ya = yg + coefficient * (yr - yg);

            cx = xb + (xr - xb) * i / count + (xg + (xa - xg) * i / count - (xb + (xr - xb) * i / count)) * j / count;
            cy = yb + (yr - yb) * i / count + (yg + (ya - yg) * i / count - (yb + (yr - yb) * i / count)) * j / count;
        }

        return {
            cx: cx,
            cy: cy,
            RGB: CxCyToRGBHex(cx, cy),
            yAxis: j, 
            xAxis: i, 
        };
    }

    

    XY2CxCYValue(xAxis, yAxis)
    {
        const maxX = this.matrix - 1;
        const maxY = this.matrix - 1;


        xAxis = xAxis > maxX ? maxX :xAxis ;
        xAxis = xAxis < 0 ? 0 :xAxis;

        yAxis =  yAxis > maxY ? maxY : yAxis ;
        yAxis =  yAxis < 0 ? 0 : yAxis;
        
      
        const coordinate = xAxis + ',' + yAxis;
        let {value,cx,cy,RGB} = this.coordinateMap[coordinate];  
        
        return {value,RGB,cx,cy,axis:{
            xAxis,yAxis
        }};
    }

    CxCy2XY(value) {
        const config = this.config
        if (!config) throw new Error('no config');
        
        // 检测配置结构决定使用哪种算法
        if (config.xy !== undefined && config.xc !== undefined) {
           return this.CxCy2XY_V2(value)
        }else{
           return this.CxCy2XY_V1(value)
        }
    }


    CxCy2XY_V1(value) {
        let {cx,cy} = this._value2CxCy(value);

        let xa, ya;
        const count = this.matrix - 1;
        const maxX = this.matrix - 1;
        const maxY = this.matrix - 1;

        const { xr, yr, xg, yg, xb, yb, coefficient } = this.config;
        xa = xg + coefficient * (xr - xg);
        ya = yg + coefficient * (yr - yg); 
        
        let A = (yr - yb) / count
        let B = (yg - yb) / count
        let C = (ya - yg - (yr - yb)) / (count * count) 

        let A1 = (xr - xb) / count
        let B1 = (xg - xb) / count
        let C1 = (xa - xg - (xr - xb)) / (count * count)

        // 定义方程组的函数和导数
        function f1(i, j) {
            return A1 * i + B1 * j + C1 * i * j - (cx - xb);
        }

        function f2(i, j) {
            return A * i + B * j + C * i * j - (cy - yb);
        }

        function df1di(i, j) {
            return A1 + C1 * j;
        }

        function df1dj(i, j) {
            return B1 + C1 * i;
        }

        function df2di(i, j) {
            return A + C * j;
        }

        function df2dj(i, j) {
            return B + C * i;
        }

        // 初始猜测值
        let i = 0;
        let j = 0;

        // 最大迭代次数和收敛阈值
        const maxIterations = count;
        const tolerance = 1e-4;

        // 迭代求解方程组
        let iteration = 0;
        let deltaI, deltaJ;
        let converged = false;

        while (iteration < maxIterations) {
            const f1Value = f1(i, j);
            const f2Value = f2(i, j);
            const det = df1di(i, j) * df2dj(i, j) - df1dj(i, j) * df2di(i, j);

            deltaI = (df2dj(i, j) * f1Value - df1dj(i, j) * f2Value) / det;
            deltaJ = (-df2di(i, j) * f1Value + df1di(i, j) * f2Value) / det;

            i -= deltaI;
            j -= deltaJ;

            if (Math.abs(deltaI) < tolerance && Math.abs(deltaJ) < tolerance) {
                converged = true;
                break;
            }

            iteration++;
        }

        // console.log(i, j, 'Approximate solution:')

      
  
      
        // 输出结果
        if (converged) {  
            let y = Math.max(0, count - Math.round(j))
            let x = Math.max(0, Math.round(i))

            return {
                yAxis: y,
                xAxis: x,
                RGB:  CxCyToRGBHex(cx, cy)
            }; 
        } else {
            return {
                yAxis: -1,
                xAxis: -1,
                RGB:'#fff'
            };
        } 

    }


    CxCy2XY_V2(value) {
        let { cx, cy } = this._value2CxCy(value);

        let minDist = Infinity;
        let nearest = null;

        for (const key in this.coordinateMap) {
            const { cx: cx0, cy: cy0 } = this.coordinateMap[key];
            const dx = cx - cx0;
            const dy = cy - cy0;
            const dist = dx * dx + dy * dy;

            if (dist < minDist) {
                minDist = dist;
                nearest = key;
            }
        }

        if (!nearest) return null;

        const [i, j] = nearest.split(',').map(Number);

        // === 中心点逆时针旋转 90° ===
        const center = (this.matrix - 1) / 2;
        const di = i - center;
        const dj = j - center;

        const rotatedI = Math.round(center - dj); // y轴
        const rotatedJ = Math.round(center + di); // x轴

        return { 
            yAxis: rotatedI,
            xAxis: rotatedJ,
            RGB: CxCyToRGBHex(cx, cy)
        };
    }

}
 

 